// SPDX-License-Identifier: LicenseRef-Proprietary

import { useState, useEffect } from 'react';

/**
 * Hook to calculate ActivityDrawer position based on header height
 * Extracts position calculation logic for better separation of concerns
 */
export function useActivityDrawerPosition() {
  const [topPosition, setTopPosition] = useState(200);
  
  // Check if we're on a compact screen
  const isCompactScreen = window.innerWidth >= 1281 && window.innerWidth <= 1920;

  useEffect(() => {
    const calculatePosition = () => {
      const header = document.querySelector('.vaccine-demo__header') as HTMLElement | null;
      
      let totalHeight = 0;
      
      if (header && header.offsetHeight) {
        totalHeight += header.offsetHeight;
      }
      
      // Add some margin to ensure no overlap
      const margin = isCompactScreen ? 20 : 30;
      const calculatedTop = totalHeight + margin;
      
      // Set minimum and maximum bounds
      const minTop = isCompactScreen ? 160 : 200;
      const maxTop = isCompactScreen ? 220 : 280;
      
      setTopPosition(Math.max(minTop, Math.min(maxTop, calculatedTop)));
    };

    // Calculate on mount and when window resizes
    calculatePosition();
    window.addEventListener('resize', calculatePosition);
    
    // Also recalculate when header content might change
    const observer = new MutationObserver(calculatePosition);
    const targetNode = document.querySelector('.vaccine-demo');
    if (targetNode) {
      observer.observe(targetNode, { childList: true, subtree: true });
    }

    return () => {
      window.removeEventListener('resize', calculatePosition);
      observer.disconnect();
    };
  }, [isCompactScreen]);

  return { topPosition, isCompactScreen };
}

